// useAnalytics.js
import { useEffect } from 'react';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { useCookieConsent } from './useCookieConsent';
import ReactGA from 'react-ga4';
//import { useLDClient } from 'launchdarkly-react-client-sdk';
import useCurrentUser from './useCurrentUser';

export const useAnalytics = (props, embed) => {
  const essentialAllowed = useCookieConsent('essential');
  const analyticsAllowed = useCookieConsent('analytics');
  const marketingAllowed = useCookieConsent('marketing');
  const { userID, partnerUserId } = useCurrentUser();
  const ldClient = false//useLDClient();

  const identifierObject = {
    kind: 'user',
    key: userID || `anonymous-${crypto.randomUUID()}`,
    partnerUserId: partnerUserId || undefined,
    userRole: props?.userRole || undefined,
    partnerCode: props?.partnerCode || undefined,
  };

  // Initialize Google Tag
  useEffect(() => {
    if (!analyticsAllowed) return;
    if (window.location.hostname !== 'localhost' && ReactGA) {
      ReactGA.initialize('G-HWN4MK2CF8');
      // console.log('GA initialized');
    } else {
      // console.log('Running on localhost - GA not initialized.');
    }
  }, [analyticsAllowed]);

  // Initialize LogRocket
  useEffect(() => {
    if (!analyticsAllowed) return;
    if (!window.location.hostname.includes('localhost') && LogRocket) {
      LogRocket.init('hmtcjk/carrier-connect');
      setupLogRocketReact(LogRocket);
      // console.log('LR initialized');
    }
    // else {
    //     console.log('Running on localhost - LR not initialized.');
    // }
  }, [analyticsAllowed]);

  // Initialize Launch Darkly
  useEffect(() => {
    if (!essentialAllowed) return;
    if (ldClient && userID) {
      ldClient.identify(identifierObject);
    }
  });

  // Track pathname
  useEffect(() => {
    if (!analyticsAllowed) return;
    if (!window.location.hostname.includes('localhost') && LogRocket) {
      if (userID) {
        LogRocket.identify(userID, identifierObject);
      }
      LogRocket.track('pageview', identifierObject);
    } else {
      // console.warn('LR is not initialized, cannot track events.');
    }

    if (!window.location.hostname.includes('localhost') && ReactGA) {
      if (userID) {
        ReactGA.set({ userId: userID, ...identifierObject });
      }
      ReactGA.send({ ...identifierObject, hitType: 'pageview', page: window.location.pathname });
    } else {
      //   console.warn('GA is not initialized, cannot track events.');
    }
  }, [identifierObject, userID, analyticsAllowed, window.location.pathname]);
};
